import { render, staticRenderFns } from "./TelegramCampaignForContractors.vue?vue&type=template&id=b60c433e"
import script from "./TelegramCampaignForContractors.vue?vue&type=script&lang=js"
export * from "./TelegramCampaignForContractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports